<template>
    <div>
      <NoneData
        v-if="!commodityList.length"
        style="background: #ffffff"
        propsText="该店铺所选时段内无关联视频信息"
        :height="6"
      />
      <div class="shop-commodity" v-else>
        <form action="/"></form>
        <div class="carrier-list-data">
          <van-list
            v-model="loading"
            :finished="finished"
            finished-text="没有更多数据了哦~"
            @load="getTableData"
          >
            <router-link
              v-for="(item, index) of commodityList"
              :key="index"
              :to="`/goods/${item.itemId}`"
            >
            <list  :key="index" :info="item" :index="index + 1"></list>
            </router-link>
          </van-list>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  import list from '@/modules/Delivery/list.vue'
  export default {
    components:{list},
    props: { query: Object },
    data() {
      return {
        params: {
          pageNum: 1,
          pageSize: 25,
          order: "desc",
          sort: "sales",
          searchText: "",
        },
        loading: true,
        count: 0,
        commodityList: [],
      };
    },
    watch: {
      query: {
        deep: true,
        immediate: true,
        handler() {
          this.params.pageNum = 1;
          this.params = {
            ...this.params,
            ...this.$props.query,
          };
          this.count = 0;
          this.commodityList = [];
          this.getTableData();
        },
      },
    },
    computed: {
      finished: (_this = this) => _this.count === _this.commodityList.length,
    },
    methods: {
      async getTableData() {
        const res = await this.$api
          .get(`/v2/shop/${this.$route.params.id}/opusStatistic`, {
            params: this.params,
          })
          .catch((_) => {});
        if (res.data.data) {
          // 如果页码等于一  第一次加载或更换日期
          this.commodityList =
            this.params.pageNum === 1
              ? res.data.data
              : this.commodityList.concat(res.data.data);
          this.params.pageNum++;
          this.count = res?.data?.paging?.count || 0;
          this.loading = false;
        }
      },
    },
  };
  </script>
  
  <style scoped lang="less">
  .loading {
    font-size: 0.24rem;
    color: #fbfafa;
    padding: 0.5rem 0.3rem;
    text-align: center;
  }

  </style>